import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RegimeAnalytics } from '../../types/entities';

import { RegimeAnalyticsState, initialRegimeAnalyticsState } from './state';

const accountInfoSlice = createSlice({
  name: 'regime-analytics',
  initialState: initialRegimeAnalyticsState,
  reducers: {
    reset: () => initialRegimeAnalyticsState,
    loading: (state: RegimeAnalyticsState, action: PayloadAction<boolean>) => {
      state.error = undefined;
      state.loading = action.payload;
      state.loaded = !action.payload;
    },
    success: (state: RegimeAnalyticsState, action: PayloadAction<RegimeAnalytics>) => {
      state.error = undefined;
      state.loading = false;
      state.loaded = true;
      state.regimeAnalytics = action.payload;
    },
    fail: (state: RegimeAnalyticsState, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
      state.loaded = true;
      state.regimeAnalytics = undefined;
    }
  }
});

const { actions, reducer } = accountInfoSlice;
export const { reset, loading, success, fail } = actions;
export default reducer;
